import Vue from "vue";
import VueCookie from "vue-cookie";

const state = {
  product: {},
  relatedProducts: [],
  isFavourite: false,
  favouritesProducts: [],
  products: [
    {
      img: "product-sample.png",
      name: "Z Peridontal Probe1",
      star: 2,
      amount: 20,
      brand: {
        name: "3M"
      },
      images: [
        {
          imageUrl: "https://i.stack.imgur.com/y9DpT.jpg",
          id: 1
        }
      ]
    },
    {
      img: "product-sample.png",
      name: "D Peridontal Probe2",
      star: 3,
      amount: 44,
      brand: {
        name: "3M"
      },
      images: [
        {
          imageUrl: "https://i.stack.imgur.com/y9DpT.jpg",
          id: 2
        }
      ]
    },
    {
      img: "product-sample.png",
      name: "R Peridontal Probe3",
      star: 4,
      amount: 36,
      brand: {
        name: "NSK"
      },
      images: [
        {
          imageUrl: "https://i.stack.imgur.com/y9DpT.jpg",
          id: 3
        }
      ]
    },
    {
      img: "product-sample.png",
      name: "C Peridontal Probe4",
      star: 5,
      amount: 17,
      brand: {
        name: "Shufu"
      },
      images: [
        {
          imageUrl: "https://i.stack.imgur.com/y9DpT.jpg",
          id: 4
        }
      ]
    },
    {
      img: "product-sample.png",
      name: "A Peridontal Probe5",
      star: 1,
      amount: 65,
      brand: {
        name: "Shufu"
      },
      images: [
        {
          imageUrl: "https://i.stack.imgur.com/y9DpT.jpg",
          id: 5
        }
      ]
    },
    {
      img: "product-sample.png",
      name: "T Peridontal Probe6",
      star: 3,
      amount: 56,
      brand: {
        name: "Danaher"
      },
      images: [
        {
          imageUrl: "https://i.stack.imgur.com/y9DpT.jpg",
          id: 6
        }
      ]
    },
    {
      img: "product-sample.png",
      name: "G Peridontal Probe7",
      star: 4,
      amount: 54,
      brand: {
        name: "Danaher"
      },
      images: [
        {
          imageUrl: "https://i.stack.imgur.com/y9DpT.jpg",
          id: 7
        }
      ]
    },
    {
      img: "product-sample.png",
      name: "H Peridontal Probe8",
      star: 1,
      amount: 87,
      brand: {
        name: "NSK"
      },
      images: [
        {
          imageUrl: "https://i.stack.imgur.com/y9DpT.jpg",
          id: 8
        }
      ]
    }
  ],
  basketProducts: [],
  orders: [
    {
      logo: "basket-product.png",
      name: "Peridontal Probe",
      brand: "product-logo.svg",
      supplier: "Dental Laser",
      packaging: "Packet",
      cost: 69
    },
    {
      logo: "basket-product.png",
      name: "Angle Handpiece",
      brand: "product-logo.svg",
      supplier: "Dental Laser",
      packaging: "Packet",
      cost: 27
    }
  ],
  category: {},
  categories: [],
  categoryId: null,
  productReviews: [],
  totalProductReviews: 0,
  averageProductRating: 0

};
const getters = {
  totalBasketItems: state => {
    return parseInt(
      state.basketProducts.reduce(
        (a, b) => parseInt(a, 10) + parseInt(b.quantity, 10),
        0
      ),
      10
    );
  },
  basketSubTotal: state => {
    return state.basketProducts
      .reduce((a, b) => a + b.amount * b.quantity, 0)
      .toFixed(2);
  },
  basketShippingFee: state => {
    return state.basketProducts
      .reduce((a, b) => a + b.shippingFee, 0)
      .toFixed(2);
  },
  basketDiscount: state => {
    return state.basketProducts.reduce((a, b) => a + b.discount, 0).toFixed(2);
  },
  basketTotal: (state, getters) => {
    return (
      parseFloat(getters.basketSubTotal) + parseFloat(getters.basketShippingFee)
    ).toFixed(2);
  },
  productBrands: state => {
    return Vue.prototype.$_.uniq(
      Vue.prototype.$_.map(state.products, function(item) {
        return item.brand.name;
      })
    );
  }
};
const mutations = {
  SET_PRODUCT_REVIEWS(state, productReviews) {
    state.productReviews = productReviews;
  },
  SET_TOTAL_PRODUCT_REVIEWS(state, totalProductReviews) {
    state.totalProductReviews = totalProductReviews;
  },
  SET_AVERAGE_PRODUCT_RATING(state, averageProductRating) {
    state.averageProductRating = averageProductRating;
  },
  CHECK_BASKET_AND_SET(state) {
    if (VueCookie.get("basket")) {
      state.basketProducts = JSON.parse(VueCookie.get("basket"));
    }
  },
  SET_CATEGORIES(state, payload) {
    let category = {};
    let categories = [];
    payload.map(a => {
      category[`${a.name}`] = a.subCategories;
      categories.push(a.name);
    });
    state.category = category;
    state.categories = categories;
  },
  SET_PRODUCT(state, payload) {
    state.product = payload;
    if (payload.subCategories.length > 0) {
      state.categoryId = payload.subCategories[0].productCategoryId;
    }
  },
  SET_RELATED_PRODUCTS(state, products) {
    state.relatedProducts = products;
  },
  SET_PRODUCTS(state, payload) {
    state.products = payload;
  },
  ADD_ITEM_TO_BASKET(state, payload) {
    let product = payload;
    const basketItem = state.basketProducts.find(
      item => item.id === product.id
    );
    if (!basketItem) {
      state.basketProducts.push({
        id: product.id,
        quantity: 1,
        name: product.name,
        images: product.images,
        brand: {
          name: product.brand.name,
          logo: product.brand.logo
        },
        subCategories: product.subCategories,
        colour: product.colour,
        description:
          product.description,
        esitmated_delivery: {
          from: 2,
          to: 5
        },
        material: "Stainless Steel",
        type: "Dental Laser",
        packaging: "Packet",
        shippingFee: product.shippingFee,
        amount: product.amount,
        discount: 0
      });
      // state.basketProducts.push({
      //     product
      //   });
      
    } else {
      basketItem.quantity = basketItem.quantity + 1;
      basketItem.shippingFee = basketItem.shippingFee + product.shippingFee;
    }
    VueCookie.set("basket", JSON.stringify(state.basketProducts), {
      expires: "1h"
    });
  },
  POP_DISH_FROM_BASKET(state, payload) {
    let product = payload;
    const basketItem = state.basketProducts.find(
      item => item.id === product.id
    );
    if (basketItem) {
      if (basketItem.quantity > 1) {
        basketItem.shippingFee =
          basketItem.shippingFee - basketItem.shippingFee / basketItem.quantity;
        basketItem.quantity = basketItem.quantity - 1;
      } else {
        state.basketProducts = [];
        VueCookie.set("basket", JSON.stringify(state.basketProducts), {
          expires: "1h"
        });
      }
    }
    VueCookie.set("basket", JSON.stringify(state.basketProducts), {
      expires: "1h"
    });
  },
  changeQuantity(state, payload) {
    let product = payload.product;
    const basketItem = state.basketProducts.find(
      item => item.id === product.id
    );
    if (basketItem) {
      if (payload.value > 0) {
        basketItem.quantity = payload.value;
        basketItem.shippingFee = basketItem.shippingFee + product.shippingFee;
      }
    }
    VueCookie.set("basket", JSON.stringify(state.basketProducts), {
      expires: "1h"
    });
  },
  REMOVE_PRODUCT_FROM_BASKET(state, payload) {
    
    let product = payload;
    state.basketProducts = state.basketProducts.filter(
      item => item.id !== product.id
    );

    console.log(JSON.stringify(state.basketProducts))
          VueCookie.set("basket", JSON.stringify(state.basketProducts), {
      expires: "1h"
    });

  },
  emptyBasket(state) {
    state.basketProducts = [];
    VueCookie.set("basket", JSON.stringify(state.basketProducts), {
      expires: "1h"
    });
  },
  SET_FAVOURITE(state, payload) {
    state.isFavourite = payload;
  },
  SET_FAVOURITES_PRODUCTS(state, payload) {
    state.favouritesProducts = payload;
  }
};

const actions = {
  GET_CATEGORIES: async function({ commit }) {
    let { data } = await Vue.prototype.$axios.get("/product_categories");
    commit("SET_CATEGORIES", data.productCategories);
  },
  LOAD_PRODUCT: async function({ commit }, payload) {
    let route = payload.split("-");
    let id = route[route.length - 1];
    let { data } = await Vue.prototype.$axios.get("/products/" + id);
    commit("SET_PRODUCT", data.product);
  },
  LOAD_PRODUCTS: async function({ commit }) {
    let { data } = await Vue.prototype.$axios.get("/products", {
      params: {
        from: 0,
        limit: 10
      }
    });
    commit("SET_PRODUCTS", data.products);
  },
  SEARCH_BY_SUBCATEGORY_ID: async function({ commit }, payload) {
    let { data } = await Vue.prototype.$axios.get(
      "/product_subcategories/" + payload + "/products"
    );
    commit("SET_PRODUCTS", data.products);
  },
  LOAD_RELATED_PRODUCTS: async function({ commit, state }) {
    if (state.categoryId !== null) {
      await Vue.prototype.$axios
        .get(
          "/product_categories/" + state.categoryId + "/products?from=0&limit=4"
        )
        .then(res => {
          commit("SET_RELATED_PRODUCTS", res.data.products);
        });
    }
  },
  CHECK_FOR_FAVOURITE: async function({ commit }, payload) {
    let route = payload.split("-");
    let id = route[route.length - 1];
    await Vue.prototype.$axios.get("/favourites/products/" + id).then(res => {
      commit("SET_FAVOURITE", res.data.success);
    });
  },
  TOGGLE_FAVOURITE: async function({ commit, state }, payload) {
    await Vue.prototype.$axios
      .post("/favourites/products/" + payload)
      .then(() => {
        commit("SET_FAVOURITE", !state.isFavourite);
      });
  },
  LOAD_FAVOURITES_PRODUCTS: async function({ commit }, payload) {
    await Vue.prototype.$axios
      .get("/favourites/products", { params: payload })
      .then(res => {
        commit("SET_FAVOURITES_PRODUCTS", res.data.products);
      });
  },
  LOAD_PRODUCT_REVIEWS: async function({ commit }, payload) {
    let route = payload.split("-");
    let id = route[route.length - 1];
    let { data } = await Vue.prototype.$axios.get("/products/" + id + '/reviews', {
      params: {
        from: 0,
        limit: 10
      }
    });
    commit("SET_PRODUCT_REVIEWS", data.productReviews);
    commit("SET_TOTAL_PRODUCT_REVIEWS", data.meta.total);
    commit("SET_AVERAGE_PRODUCT_RATING", data.meta.average);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
